module.exports = __webpack_public_path__ + "img/32.3f91afe9.png";